import { useEffect, useState } from "react";
import AppConst from "../apis/appconst";
import axios from "axios";

function OwnProfile() {
 const [formData, setFormData] = useState({
        profile_name:'',
        profile_own_name: '',
        profile_designation: '',
        profile_state: '',
        profile_phone: '',
        profile_address: '',
        profile_user: '',
        alertMsg: '',
        alertMsgTyp: '',
        isAlert: false,
      });

     

    const [ldata, setLdata] = useState(null);

      const handleChange = (e) => {
       
        const { name, value } = e.target;
        setFormData(prev => ({
          ...prev,
          [name]: value
        }));
      };

      const handleSubmit = async (e) => {
        e.preventDefault();
        // alert(formData.email+"");
        const fd = new FormData();
        fd.append('profile_name', formData.profile_name);
        fd.append('profile_own_name', formData.profile_own_name);
        fd.append('profile_designation', formData.profile_designation);
        fd.append('profile_state', formData.profile_state);
        fd.append('profile_phone', formData.profile_phone);
        fd.append('profile_address', formData.profile_address);
        fd.append('profile_user', ldata.user_id);
        
        try {
            const response = await axios.post(AppConst.BASE_URL+AppConst.upProfileUrl, fd, {
                headers: {
                'Content-Type': 'multipart/form-data',
                },
            });

            if(response.data.status){
                setFormData(prev => ({
                    ...prev,
                    isAlert: true,
                    alertMsg: response.data.success,
                    alertMsgTyp: response.data.type,
                  }));
                initData();
            }
            else{
                setFormData(prev => ({
                    ...prev,
                    isAlert: true,
                    alertMsg: response.data.success,
                    alertMsgTyp: response.data.type,
                  }));
            }
        } catch (error) {
            setFormData(prev => ({
                ...prev,
                isAlert: true,
                alertMsg: "Failed",
                alertMsgTyp: "danger",
              }));
        }
        
      };
    const initData = async() => {
        const storedData = sessionStorage.getItem("ldata");
        if (storedData) {
            const parsed = JSON.parse(storedData);
            setLdata(parsed);
            
            if(parsed!=null && parsed!=undefined){
                const fd = new FormData();
                fd.append('profile_user', 1);
                try {
                    const response = await axios.post(AppConst.BASE_URL+AppConst.getProfileUrl, fd, {
                        headers: {
                        'Content-Type': 'multipart/form-data',
                        },
                    });
                    if(response.data.status){
                        
                        var user_dt = response.data.user_dt;
                        if(user_dt!=null && user_dt!=undefined){
                            setFormData(prev => ({
                                ...prev,
                                profile_name:user_dt.profile_name,
                                profile_own_name: user_dt.profile_own_name,
                                profile_designation: user_dt.profile_designation,
                                profile_state: user_dt.profile_state,
                                profile_phone: user_dt.profile_phone,
                                profile_address: user_dt.profile_address,
                                profile_user: user_dt.profile_user,
                              }));
                        }
                    }
                } catch (error) {
                   
                }
            }
        }
      };

    useEffect(() => {
        console.log('Component mounted');
    
        initData();
    
        return () => {
          console.log('Component unmounted');
        };
      }, []);

    return (
        <div class="page-content">
            <div class="container-fluid">
                <div class="row">
                {/* <div class="col-xxl-2"></div> */}
                    <div class="col-xxl-12">
                        <div class="card">
                            

                            <div class="card-body">
                                <h5>Owner Profile</h5>
                                <br/>
                                <div class="live-preview">
                                    <form onSubmit={handleSubmit}>
                                        <div class="row">
                                            <div class="col-md-6">
                                                <div class="mb-3">
                                                    <label for="firstNameinput" class="form-label">Hospital Name</label>
                                                    <input type="text" name="profile_name" onChange={handleChange} value={formData.profile_name} class="form-control" placeholder="Enter your Hospital Name" id="firstNameinput"/>
                                                </div>
                                            </div>
                                            
                                            <div class="col-md-6">
                                                <div class="mb-3">
                                                    <label for="lastNameinput" class="form-label">Owner Name</label>
                                                    <input type="text" name="profile_own_name" onChange={handleChange} value={formData.profile_own_name} class="form-control" placeholder="Enter your Owner Name" id="lastNameinput"/>
                                                </div>
                                            </div>
                                            
                                            <div class="col-md-4">
                                                <div class="mb-3">
                                                    <label for="compnayNameinput" class="form-label">Designation</label>
                                                    <input type="text" name="profile_designation" onChange={handleChange} value={formData.profile_designation} class="form-control" placeholder="Enter Designation" id="compnayNameinput"/>
                                                </div>
                                            </div>
                                            
                                           
                                            <div class="col-md-4">
                                                <div class="mb-3">
                                                    <label for="compnayNameinput" class="form-label">State</label>
                                                    <input type="text" name="profile_state" onChange={handleChange} value={formData.profile_state} class="form-control" placeholder="Enter State" id="compnayNameinput"/>
                                                </div>
                                            </div>
                                            
                                            <div class="col-md-4">
                                                <div class="mb-3">
                                                    <label for="phonenumberInput" class="form-label">Phone Number</label>
                                                    <input type="phone" name="profile_phone" onChange={handleChange} value={formData.profile_phone} class="form-control" placeholder="Phone Number" id="phonenumberInput"/>
                                                </div>
                                            </div>
                                            <div class="col-md-12">
                                                <div class="mb-3">
                                                    <label for="phonenumberInput" class="form-label">Address</label>
                                                    <textarea class="form-control" onChange={handleChange} name="profile_address" placeholder="Address" id="phonenumberInput">{formData.profile_address}</textarea>
                                                </div>
                                            </div>
                                            {formData.isAlert ?
                                    <div class="col-lg-12">
                                        <br/>
                                     <div class="alert alert-success material-shadow" role="alert">
                                        {formData.alertMsg}
                                    </div>
                                    </div>
                                     : <></>}
                                            <div class="col-lg-12">
                                                <div class="text-end">
                                                    <button type="submit" class="btn btn-primary">Submit</button>
                                                </div>
                                            </div>
                                            
                                        </div>
                                        
                                    </form>
                                </div>
                                
                            </div>
                        </div>
                    </div> 
                    {/* <div class="col-xxl-2"></div> */}
                </div>
            </div>
        </div>
    );
}

export default OwnProfile;
